import { APIAttachment } from '@ardoq/api-types';
import { IconName } from '@ardoq/icons';

export type EntityAttachmentType = 'image' | 'document' | 'misc';

const IMAGE_CONTENT_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/svg+xml',
];

const DOCUMENT_CONTENT_TYPES = ['application/pdf'];

export const toAttachmentType = (
  contentType: APIAttachment['content-type']
): EntityAttachmentType => {
  if (!contentType) {
    return 'misc';
  }

  if (IMAGE_CONTENT_TYPES.includes(contentType)) {
    return 'image';
  }

  if (DOCUMENT_CONTENT_TYPES.includes(contentType)) {
    return 'document';
  }

  return 'misc';
};

export const toAttachmentIcon = (type: EntityAttachmentType): IconName => {
  switch (type) {
    case 'image':
      return IconName.COLLECTIONS;
    case 'document':
      return IconName.FILE;
    case 'misc':
    default:
      return IconName.MISC;
  }
};
